import { spaceCadet, ultraMarine } from '@cogneed/react-utils';
import { styled } from '@mui/material';

const StyledDiv = styled('div')(({ theme }) => ({
  '& .Collapsible__container': {
    backgroundColor: spaceCadet[100],
    borderRadius: 4,
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 8,

    '&:hover': {
      backgroundColor: ultraMarine[100],
    },

    '& .Collapsible__title': {
      cursor: 'pointer',
      position: 'relative',
      display: 'block',
      outline: 'none',
      padding: '6px 8px',
      userSelect: 'none',

      '&::before': {
        borderStyle: 'solid',
        borderColor: 'transparent',
        borderWidth: '5px 5px 0 5px',
        borderRadius: '4px',
        display: 'block',
        content: '""',
        position: 'absolute',
        right: '15px',
        top: '50%',
        transform: 'translateY(-50%) rotate(0deg)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.standard,
        }),
      },
    },

    '& .Collapsible__content': {
      overflow: 'hidden',
      padding: '0px 8px',
      transition: theme.transitions.create('height', {
        duration: theme.transitions.duration.standard,
      }),
    },

    '&[data-lexical-is-expanded]': {
      backgroundColor: '#F2F7FF',

      '& .Collapsible__title': {
        fontWeight: 'bold',

        '&::before': {
          transform: 'translateY(-50%) rotate(180deg)',
        },
      },

      '& .Collapsible__content': {
        padding: '4px 8px',
        transition: theme.transitions.create('height', {
          duration: theme.transitions.duration.standard,
        }),
      },
    },

  },
  '& .PlaygroundEditorTheme__ul': {
    '& .PlaygroundEditorTheme__listItem': {
      '&.PlaygroundEditorTheme__listItemUnchecked': {
        '&:before': {
          border: `1px solid ${spaceCadet[500]}`,
          borderRadius: 2,
        },
      },
      '&.PlaygroundEditorTheme__listItemChecked': {
        textDecoration: 'none',
        '&:before': {
          borderRadius: 2,
          backgroundColor: ultraMarine[500],
          display: 'block',
          width: 16,
          height: 16,
          backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath"
            + " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 "
            + "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
          content: '""',
        },
      },
    },
  },

  '& .Block': {
    backgroundColor: spaceCadet[100],
    borderRadius: 4,
    marginBottom: 8,
    padding: '8px 12px',
    '&.hidden': {
      display: 'none',
    },
  },
}));

export default StyledDiv;
